// extracted by mini-css-extract-plugin
module.exports = {"declaration-modal":"ContractDeclarationFormModal-module__declaration-modal___3OoJh","declarationModal":"ContractDeclarationFormModal-module__declaration-modal___3OoJh"};